import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-loader flex-column"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_3 = { class: "text-muted fs-6 fw-bold mt-5" }
const _hoisted_4 = {
  key: 1,
  class: "page-loader page-loader-logo"
}
const _hoisted_5 = { class: "container text-center itens-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/logos/hc-pink.png",
  width: "500"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_12 = { class: "text-muted fs-3 fw-bold mt-5" }
const _hoisted_13 = {
  key: 2,
  class: "page-loader"
}
const _hoisted_14 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_15 = { class: "visually-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaderType === 'spinner-message')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
      ]))
    : (_ctx.loaderType === 'spinner-logo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, "   Hacking " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)) + "...", 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
          ])
        ]))
}